import type { NavItem } from '../types';

export const navItems: NavItem[] = [
  { label: 'Team Dashboard', path: '/time' },
  { label: 'Timesheets', path: '/time/timesheet-approval' },
  { label: 'Payroll Export', path: '/time/payroll-export' },
  { label: 'Time Off Requests', path: '/time/time-off-requests' },
  {
    label: 'Settings',
    path: '/time/settings',
    requireManagerOrAdmin: true,
    children: [
      { label: 'Pay Rules', path: '/time/settings' },
      { label: 'Holidays', path: '/time/settings/holidays' },
      { label: 'Flag Rules', path: '/time/settings/flags' },
    ],
  },
];
